import { toast } from "@/components/shadcn/ui/use-toast";
import { useProductWithBusiness } from "@/hook/useProductWithBusiness";
import { useState, useEffect } from "react";
import React from "react";
import { useParams } from "react-router-dom";
import extenso from 'extenso'
import Modal from "./modal";
import FeatureModal from "./featuredModal";
import { useProduct } from "@/hook/useProduct";
import { ProductWithBusiness } from "@/entities/businessProduct";
import { Product } from "@/entities/product";

// Definição do tipo esperado para os dados
interface BusinessData {
    productId: number;
    businessId: number;
    discount: number;
    quantity: number;
    deploy: number;
    total: number;
    price: number;
    product: {
        name:string;
        description: string;
    };
    business: {
        clientId: number;
        contactNumber: string | null;
        email: string | null;
        client: {
            responsible: string;
            fantasyName: string;
            corporateName: string;
            cpfCnpj: string;
            contacts: any[]; // Pode ser melhor definido se soubermos a estrutura dos contatos
        };
        businessSellers: {
            id: number;
            SellerId: number;
            Seller: {
                id: number;
                name: string;
                email: string;
                phone: string;
                commission: number;
            }
        }[];
    };
}


const PrintComponent = () => {
    const [selectedFeatures, setSelectedFeatures] = useState<string[]>([]);
    const [dados, setDados] = useState<BusinessData[]>([]); // Inicializa como array vazio
    const { getInfosBusinessProduct } = useProductWithBusiness();
    const {moduleUse, getAllmodule, getAllModulesByBusiness} = useProduct();
    const { leadId } = useParams<{ leadId: string }>();
    const [dados2,setDados2] = useState<string[]>([]);
    const leadId2Set = Number(leadId);
    const data = new Date();
    const month = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][data.getMonth()];
    const year = data.getFullYear();
    const date = data.getDate();
    const [modalwCompany, setModalwCompany] = useState(false);
    const [formaPgmt, setFormaPgmt] = useState('');
    const [modalxPDV, setModalxPDV] = useState(false);
    
    const selectedFeaturesHtml = selectedFeatures.map(feature => `
        <li class="text-sm font-narrow">
          ➢ ${feature}
        </li>
      `).join('');


    const getDados = async () => {
        try {
            const response = await getInfosBusinessProduct(leadId2Set);
            const response2 = await getAllModulesByBusiness(leadId2Set);
            if(response2) {
                const names = response2.map((product: { product: { name: string; }; }) => product.product.name);
                setDados2(names);
            }
            if (response?.data) {
                setDados(response.data); 
            } else {
                console.warn("Resposta vazia da API");
            }
        } catch (error) {
            console.error("Erro ao buscar os dados:", error);
        }
    };

    useEffect(() => {
        getAllmodule();
        getDados();
        console.log(dados2);
    }, []);

    const generateHTMLW = () => {
        if (dados.length === 0) {
            return `<p>Usuario não possui produtos vinculados</p>`;
        }
        return `<!DOCTYPE html>
<html lang="pt-br">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Proposta Comercial</title>
    <script src="https://cdn.tailwindcss.com"></script>
    <script>
        tailwind.config = {
            theme: {
                extend: {
                    fontFamily: {
                        narrow: ['Arial Narrow', 'sans-serif'],
                    },
                },
            },
        };
    </script>
    <style>
        @page {
            size: A4;
            /* Melhor declarar explicitamente o tamanho */
            margin: 0;
        }

        @media print {
            #noprint {
                display: none;
            }

            html,
            body {
                width: 210mm;
                height: 297mm;
                margin: 0;
                padding: 0;
            }

            .container {
                min-height: 100vh;
                display: flex;
                margin-left:auto;
                margin-right: auto;
                flex-direction: column;
                justify-content: space-between;
                
            }

            .container main {
                flex: 1;
                overflow: hidden;
            }

            header,
            footer {
                page-break-inside: avoid;
            }

            .new-page {
                page-break-before: always;
            }
        }

        .table-container {
            border: 1px solid black;
            width: 70%;
            border-collapse: collapse;
        }

        .table-container td,
        .table-container th {
            border: 1px solid black;
            padding: 8px;
        }

        .highlight {
            color: red;
            font-style: italic;
            font-weight: bold;
        }
    </style>
</head>

<body class="h-screen w-screen flex flex-col justify-between">
    <div class="container flex flex-col justify-between h-screen px-4">
        <button id="noprint" type="button" onclick="window.print()"
            class="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Imprimir</button>

        <!-- Primeira Página -->
        <header class="flex flex-row justify-between items-center">
            <img src="https://imgur.com/01PjkOR.png" class="h-[70px]" alt="nextcompany">
            <div class="pl-3 flex flex-col border-black border-l">
                <p class="font-narrow text-xs">Rua Fernando Pires Leal Nº 2000, São João, Teresina - PI</p>
                <p class="font-narrow text-xs">CEP 64045-550 Fone: 086 3301-5350</p>
                <p class="font-narrow text-xs"><a href="https://www.nextcompany.com.br/">www.wcompany.com.br</a> Email:
                    infocom@wcompany.com.br</p>
            </div>
        </header>

        <main  class="flex mt-[300px] flex-col h-auto justify-center items-center flex-grow">
            <p class="font-narrow text-3xl uppercase"><u>${dados[0].business.client.corporateName}</u></p>
            <p class="font-narrow text-3xl mt-4"><u>PROPOSTA COMERCIAL</u></p>
            <p class="font-narrow text-3xl mt-4 "><u>Versão 1.0</u></p>
        </main>

        <footer  class="flex mt-[300px] flex-col items-center">
            <div class="w-full text-right">
                <p>Teresina, ${date} de ${month} de ${year}</p>
            </div>
            <p>------------------------------------------------------------------------------------------</p>
            <p class="font-narrow text-xs text-center text-blue-600">
                Sua melhor oportunidade em conectividade!!!
            </p>
        </footer>
    </div>

    <div class="new-page container flex flex-col justify-between h-screen px-4">
        <header class="flex flex-row justify-between items-center">
            <img src="https://imgur.com/01PjkOR.png" class="h-[70px]" alt="nextcompany">
            <div class="pl-3 flex flex-col border-black border-l">
                <p class="font-narrow text-xs">Rua Fernando Pires Leal Nº 2000, São João, Teresina - PI</p>
                <p class="font-narrow text-xs">CEP 64045-550 Fone: 086 3301-5350</p>
                <p class="font-narrow text-xs"><a href="https://www.nextcompany.com.br/">www.wcompany.com.br</a> Email:
                    infocom@wcompany.com.br</p>
            </div>
        </header>

        <main>
            <main>

                <div class="max-w-3xl mx-auto bg-white p-6 rounded-lg">
                    <h1 class="text-xl font-bold">1.0 DO SISTEMA:</h1>
                    <div class="flex flex-col">
                        <div class="flex flex-row">
                            <p class="mr-2 mb-3 narrow text-sm">Sistema:</p>
                            <p class="narrow text-sm">wCompany – Sistema de Gestão Comercial</p>
                        </div>
                        <div class="flex flex-row">
                            <p class="mr-2 mb-4 narrow text-sm">Descrição:</p>
                            <p class="narrow text-sm mb-3"> Sistema integrado desenvolvido com o objetivo de automatizar
                                os mais diversos
                                processos realizados em estabelecimentos comerciais, bem como gerenciar e analisar o
                                fluxo
                                de informações apresentando os resultados que contribuam para controle e
                                acompanhamento dos negócios. Atende a exigência da legislação municipal, estadual
                                e federal.</p>
                        </div>
                        <div class="flex flex-row">
                            <p class="mr-2 mb-4 narrow text-sm">Plataforma:</p>
                            <p class="narrow text-sm"> Sistema web com banco de dados PostgreSQL.</p>
                        </div>
                    </div>
                    <p class="font-narrow text-base"><u>Principais Recursos do Chec-out e Totem Autoatendimento:</u></p>
                    <ul class="pl-4 text-xs mb-3">
                        <li class="text-sm font-narrow"><strong>➢ Realização de Compras</strong></li>
                        <li class="text-sm font-narrow"><strong>➢ Feednack e Avaliações</strong></li>
                        <li class="text-sm font-narrow"><strong>➢ Pagamento Rápido</strong></li>
                        <li class="text-sm font-narrow"><strong>➢ Consulta Preço de Produtos</strong></li>
                        <li class="text-sm font-narrow"><strong>➢ Check-out</strong></li>
                    </ul>
                    <p class="font-narrow text-base"><u>Principais Recursos do Assistente de Vendas:</u></p>
                    <ul class="pl-4 text-xs mb-3">
                        <li class="text-sm font-narrow">➢ Cadastro de Clientes.</li>
                        <li class="text-sm font-narrow">➢ Pré-venda / Orçamento;</li>
                        <li class="text-sm font-narrow">➢ Vendas Balcão.</li>
                    </ul>
                    <p class="font-narrow text-base"> <u>Principais Recursos do Módulo de BackOffice:</u></p>
                    <ul class="pl-4 text-xs mb-3">
                        <li class="text-sm font-narrow">➢ Caixas</li>
                        <li class="text-sm font-narrow">➢ Bancos</li>
                        <li class="text-sm font-narrow">➢ Gestão de Contas</li>
                        <li class="text-sm font-narrow">➢ Tele-Cobrança</li>
                        <li class="text-sm font-narrow">➢ Cobrança Eletrônica Boletos</li>
                        <li class="text-sm font-narrow">➢ DRE
                        </li>
                        <li class="text-sm font-narrow">➢ Fluxo de Caixa</li>
                    </ul>
                    <p class="font-narrow text-base"> <u>Principais Recursos do Módulo de Retaguarda:</u></p>
                    <ul class="pl-4 text-xs mb-3">
                        <li class="text-sm font-narrow">➢ Gestão de Compras</li>
                        <li class="text-sm font-narrow">➢ Gestão de Estoque</li>
                        <li class="text-sm font-narrow">➢ Cargas / Entregas</li>
                        <li class="text-sm font-narrow">➢ Gestão Fiscal e Tributária</li>
                    </ul>
                    <p><u>Módulos Adicionais:</u></p>
                    <ul class="font-narrow text-base pl-4">
                        ${selectedFeaturesHtml}
                    </ul>
                </div>

            </main>

            <footer class="flex flex-col items-center">
                <p>------------------------------------------------------------------------------------------</p>
                <p class="font-narrow text-xs text-center text-blue-600">
                    Sua melhor oportunidade em conectividade!!!
                </p>
            </footer>
    </div>
    <div class="new-page container flex flex-col justify-between h-screen px-4">
        <header class="flex flex-row justify-between items-center">
            <img src="https://imgur.com/01PjkOR.png" class="h-[70px]" alt="nextcompany">
            <div class="pl-3 flex flex-col border-black border-l">
                <p class="font-narrow text-xs">Rua Fernando Pires Leal Nº 2000, São João, Teresina - PI</p>
                <p class="font-narrow text-xs">CEP 64045-550 Fone: 086 3301-5350</p>
                <p class="font-narrow text-xs"><a href="https://www.nextcompany.com.br/">www.wcompany.com.br</a> Email:
                    infocom@wcompany.com.br</p>
            </div>
        </header>
        <main >
            <div class="max-w-3xl mx-auto bg-white p-6 rounded-lg">
                <h1 class="text-xl font-bold mb-4">2.0 - DA IMPLANTAÇÃO:</h1>
                <div class="flex flex-row">
                    <p class="font-narrow text-sm">Descrição:</p>
                    <p class="font-narrow text-sm ml-4 text-red-600"><strong>Trata-se do processo de planejamento,
                            instalação, configuração de parâmetros e todos os processos internos dos sistemas
                            necessários ao funcionamentos do mesmo</strong></p>
                </div>
                <ul class="list-disc pl-4 text-sm font-narrow">
                    <li>Levantamento de requisitos referente a forma de trabalho do cliente e adqueção de uso ao
                        sistema;</li>
                    <li>Análise de recursos referente aos principais cadastros;</li>
                    <li>Análise de recursos referente a tributação;</li>
                    <li>Análise de necessidades de relatórios diários, semanais e mensais; </li>
                </ul>
                <div class="flex flex-col">
                    <div class="flex flex-row">
                        <p class="font-narrow text-sm">Treinamento:</p>
                        <p class="font-narrow text-sm ml-3">Processo necessário para qualificação dos recursos humanos
                            da empresa na utilização dos sistemas em níveis operacionais, gerenciais e administrativo.
                            </br>O Tempo de implantação é que determina o valor do mesmo e este tempo é estipulado de
                            acordo com a quantidade de rotinas do sistema que serão utilizados.</p>
                    </div>
                    <div class="flex flex-row">
                        <p class="font-narrow text-sm">Migração:
                        </p>
                        <p class="font-narrow text-sm ml-3">Quando da necessidade de migração de dados de um banco de
                            dados de sistema legado para o novo, será efetuado um estudo de viabilidade para migração
                            dos cadastros e de movimentos e quando viável amento para os usuários do sistema.</p>
                    </div>
                </div>

                <h2 class="text-sm font-bold mt-4">Serviços de Implantação, Treinamento:</h2>
                <table class=" w-full h-[120px] border border-gray-300 mt-2 text-left">
                    <thead>
                        <tr class="bg-gray-200">
                            <th class="border text-sm px-4 py-2">Item</th>
                            <th class="border text-sm px-4 py-2">Descrição</th>
                            <th class="border text-sm px-4 py-2">Qtd.</th>
                            <th class="border text-sm px-4 py-2">Valor unitário R$</th>
                            <th class="border text-sm px-4 py-2">Valor total R$</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${dados
                        .map(
                        (item, index) => `
                        <tr>
                            <td class="border text-sm px-4 py-2">${index + 1}</td>
                            <td class="border text-sm px-4 py-2">${item.product.name}</td>
                            <td class="border text-sm px-4 py-2">${item.quantity}</td>
                            <td class="border text-sm px-4 py-2">${new Intl.NumberFormat('pt-BR', { style: 'currency',
                                currency: 'BRL' }).format(item.deploy)}</td>
                            <td class="border text-sm px-4 py-2">${new Intl.NumberFormat('pt-BR', { style: 'currency',
                                currency: 'BRL' }).format(item.deploy)}</td>
                        </tr>
                        `
                        )
                        .join("")}
                    </tbody>
                </table>
                <p class="mt-2 text-red-600 font-bold">
                    Extenso:(${extenso(dados.reduce((total, item) => total + (item.deploy), 0), { mode: 'currency'
                    })}).Pagamento a Prazo
                    ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(dados.reduce((total,
                    item) => total + (item.deploy), 0))}
                </p>
                <p class="font-narrow text-sm">Condições Comerciais:</p>
                <ul class="list-disc pl-4 text-sm font-narrow">
                    <li>Pagamento >> ${formaPgmt}</li>
                    <li>Faturamento: Inicio da Implantação;</li>
                    <li>Para implantação em cidades com distância superior a 50 km da sede da contratada, as despesas de
                        <u> transporte, traslado, alimentação e hospedagem</u> serão por conta da contratante;</li>
                    <li>Início da Implantação: Imediatamente.</li>
                </ul>
            </div>
        </main>
        <footer class="flex flex-col items-center">
            <p>------------------------------------------------------------------------------------------</p>
            <p class="font-narrow text-xs text-center text-blue-600">
                Sua melhor oportunidade em conectividade!!!
            </p>
        </footer>
    </div>
    <div class="new-page container flex flex-col justify-between h-screen px-4">
        <header class="flex flex-row justify-between items-center">
            <img src="https://imgur.com/01PjkOR.png" class="h-[70px]" alt="nextcompany">
            <div class="pl-3 flex flex-col border-black border-l">
                <p class="font-narrow text-xs">Rua Fernando Pires Leal Nº 2000, São João, Teresina - PI</p>
                <p class="font-narrow text-xs">CEP 64045-550 Fone: 086 3301-5350</p>
                <p class="font-narrow text-xs"><a href="https://www.nextcompany.com.br/">www.wcompany.com.br</a> Email:
                    infocom@wcompany.com.br</p>
            </div>
        </header>
        <main>
            <h3 class="mt-6 text-xl font-semibold">3.0 DO LICENCIAMENTO:</h3>
            <div class="flex flex-row">
                <p class="font-narrow text-sm">Descrição:</p>
                <p class="font-narrow text-sm ml-4 text-red-600">Contratação do direito de uso do sistema de forma
                    temporária com pagamento mensal. No licenciamento, além do direito de uso, o cliente também passa a
                    ter direito no suporte técnico que abrange correções e atualizações tecnológicas do sistema.</p>
            </div>
            <div class="max-w-4xl mx-auto text-sm bg-white p-6 rounded-lg ">
                <h2 class="text-sm font-semibold">Manutenção mensal com licenciamento temporário:</h2>

                <table class="w-full border-collapse border border-gray-300 mt-4">
                    <thead>
                        <tr class="bg-gray-200">
                            <th class="border border-gray-300 px-2 text-sm">Item</th>
                            <th class="border border-gray-300 px-2 text-sm">Descrição</th>
                            <th class="border border-gray-300 px-2 text-sm">Qtd.</th>
                            <th class="border border-gray-300 px-2 text-sm">Valor Unitário R$</th>
                            <th class="border border-gray-300 px-2 text-sm">Valor Total R$</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${dados
                        .map(
                        (item, index) => `
                        <tr>
                            <td class="border border-gray-300 text-sm px-2 py-1 text-center">${index + 1}</td>
                            <td class="border border-gray-300 text-sm px-2 py-1">${item.product.name}</td>
                            <td class="border border-gray-300 text-sm px-2 py-1 text-center">${item.quantity}</td>
                            <td class="border border-gray-300 text-sm px-2 py-1 text-center">${new
                                Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.price)}
                            </td>
                            <td class="border border-gray-300 text-sm px-2 py-1 text-center">${new
                                Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.price)}
                            </td>
                        </tr>
                        `
                        )
                        .join("")}
                        <tr class="bg-gray-200 font-semibold">
                            <td colspan="4" class="border border-gray-300 px-2 text-sm text-right">Total R$>></td>
                            <td class="border border-gray-300 px-2 text-sm text-right">${new Intl.NumberFormat('pt-BR',
                                { style: 'currency', currency: 'BRL' }).format(dados.reduce((total, item) => total +
                                (item.price - item.discount), 0))}</td>
                        </tr>
                    </tbody>
                </table>

                <p class="mt-4 text-lg font-semibold uppercase">Valor total mensal R$ ${new Intl.NumberFormat('pt-BR', {
                    style: 'currency', currency: 'BRL' }).format(dados.reduce((total, item) => total + (item.price -
                    item.discount), 0))}, EXTENSO: (${extenso(dados.reduce((total, item) => total + (item.price -
                    item.discount), 0), { mode: 'currency' })})</p>
                <div class="border-black border-2">
                    <h3 class="mt-6 font-semibold">Condições Comerciais:</h3>
                    <ul class="list-disc pl-6 mt-2 ">
                        <li>Para suporte técnico presencial em cidades com distância superior a 50 km da sede da
                            contratada, as despesas de <u> alimentação, transporte e hospedagem</u> serão por conta da
                            contratante;</li>
                        <li>Faturamento: 30 (trinta) dias após início da implantação;</li>
                        <li>Forma de pagamento do licenciamento: mensal;</li>
                        <li>Duração do contrato: mínimo de 24 (vinte e quatro) meses;</li>
                        <li>Reajuste: anual de acordo com o reajuste do salário mínimo vigente no país.</li>
                    </ul>
                </div>

                <h3 class="mt-6 text-xl font-semibold">4.0 DA PROPOSTA:</h3>
                <ul class="list-disc pl-6 mt-2 ">
                    <li>Esta proposta não é documento contratual da implantação do sistema;</li>
                    <li>Esta proposta exige um contrato adicional para implantação e licenciamento do sistema;</li>
                    <li>Esta proposta tem validade de 30 (trinta) dias a partir da data de emissão.</li>
                </ul>
                <p class="mt-4 text-sm">Teresina,${date} de ${month} de ${year}.</p>
                <p class="font-bold text-sm">Atenciosamente,</p>
                <div class="flex flex-row w-full justify-between">
                    <div class="mt-6">
                        <div class="mt-6 border-b w-[250px] border-black"></div>
                        <p class="">${dados[0].business.businessSellers[0]?.Seller?.name || ''}</p>
                    </div>

                    <div class="mt-6 ">
                        <p class="font-bold border-t w-[250px] border-black mt-6">Aceite:</p>
                    </div>
                </div>
            </div>
        </main>
        <footer class="flex flex-col items-center">
            <p>------------------------------------------------------------------------------------------</p>
            <p class="font-narrow text-xs text-center text-blue-600">
                Sua melhor oportunidade em conectividade!!!
            </p>
        </footer>
    </div>
</body>

</html>`
    }


    const generateHTML = () => {
        if (dados.length === 0) {
            return `<p>Usuario não possui produtos vinculados</p>`;
        }
        return `<!DOCTYPE html>
<html lang="pt-br">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Proposta Comercial</title>
    <script src="https://cdn.tailwindcss.com"></script>
    <script>
        tailwind.config = {
            theme: {
                extend: {
                    fontFamily: {
                        narrow: ['Arial Narrow', 'sans-serif'],
                    },
                },
            },
        };
    </script>
    <style>
        body {
            font-family: "Arial Narrow", sans-serif;
        }

        @page {
            size: A4;
            /* Melhor declarar explicitamente o tamanho */
            margin: 0;
        }

        @media print {
            #noprint {
                display: none;
            }

            html,
            body {
                width: 210mm;
                height: 297mm;
                margin: 0;
                padding: 0;
            }

            .container {
                min-height: 100vh;
                display: flex;
                margin-left: auto;
                margin-right: auto;
                flex-direction: column;
                justify-content: space-between;

            }

            .container main {
                flex: 1;
                overflow: hidden;
            }

            header,
            footer {
                page-break-inside: avoid;
            }

            .new-page {
                page-break-before: always;
            }
        }

        .table-container {
            border: 1px solid black;
            width: 70%;
            border-collapse: collapse;
        }

        .table-container td,
        .table-container th {
            border: 1px solid black;
            padding: 8px;
        }

        .highlight {
            color: red;
            font-style: italic;
            font-weight: bold;
        }
    </style>
</head>

<body class="h-screen w-screen flex flex-col justify-between">
    <div class="container flex flex-col justify-between h-screen px-4">
        <button id="noprint" type="button" onclick="window.print()"
            class="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-xs px-5 py-2.5 text-center me-2 mb-2">Imprimir</button>

        <!-- Primeira Página -->
        <header class="flex flex-row justify-between items-center">
            <img src="https://imgur.com/01PjkOR.png" class="h-[70px]" alt="nextcompany">
            <img src="https://imgur.com/03VWLf0.png" class="h-[80px]" alt="axell">
        </header>

        <main class="flex items-start mt-4 flex-col h-auto justify-center items-center flex-grow">
            <p class="font-narrow text-3xl uppercase"><u>${dados[0].business.client.fantasyName}</u></p>
            <p class="font-narrow text-3xl mt-4"><u>PROPOSTA COMERCIAL</u></p>
            <p class="font-narrow text-3xl mt-4 "><u>${dados[0].product.name}</u></p>
        </main>

        <footer class="flex items-start mt-4 flex-col items-center">
            <p>------------------------------------------------------------------------------------------</p>
            <p class="font-narrow text-xs text-center">
                Next Company - Infocom Informática - Rua Fernando Pires Lead, Nº 2000 - Teresina PI - (86) 3301-5350
            </p>
        </footer>
    </div>

    <!-- Nova Página -->
    <div class="new-page container flex flex-col justify-between h-screen px-4">
        <header class="flex flex-row justify-between items-center">
            <img src="https://imgur.com/01PjkOR.png" class="h-[70px]" alt="nextcompany">
            <img src="https://imgur.com/03VWLf0.png" class="h-[80px]" alt="axell">
        </header>

        <main class="flex flex-col justify-center items-center flex-grow">
            <main >
                <table class="w-[70%] h-[200px] table-container text-left table-auto">
                    <tr>
                        <td class="highlight w-2/3">Cliente:<br />${dados[0].business.client.fantasyName}</td>
                        <td class="highlight w-1/3 id=" data"">Data:</br> ${data.toLocaleDateString()}</td>
                    </tr>
                    <tr>
                        <td class="highlight">Razão Social:<br />${dados[0].business.client.corporateName}</td>
                        <td class="highlight">CNPJ:<br />${dados[0].business.client.cpfCnpj}</td>
                    </tr>
                    <tr>
                        <td class="highlight">Contato:<br />${dados[0].business.client.responsible}</td>
                        <td class="highlight">Fone:<br />${dados[0].business.contactNumber}</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="highlight">Email:<br />${dados[0].business.email}</td>
                    </tr>
                </table>

                <div class="w-full mt-2">
                    <h1 class="text-xl font-narrow"strong>1.0 - CARACTERÍSTICAS DO SISTEMA:</h1>
                    <ul class="list-disc pl-4 text-xs">
                        <li>Gestão financeira</li>
                        <li>Gestão de compras</li>
                        <li>Gestão de estoque</li>
                        <li>Três usuários ativos</li>
                        <li>Atende às exigências legais e fiscais</li>
                        <li>Relatórios e gráficos personalizáveis</li>
                        <li>Segurança das informações</li>
                        <li>Regras fiscais que atendem todas as regras de tributação</li>
                        <li>Atende às exigências do FISCO como EFD Contribuições e SPED Fiscal</li>
                        <li>Controle de ordem de serviços de autoatendimento para oficinas</li>
                        <li>Integra boleto bancário ao banco</li>
                        <li>Processamento de comissão de vendas</li>
                        <li>Interface intuitiva e usabilidade</li>
                    </ul>
                </div>
                <div class="w-full mt-2">
                    <p class="mt-6">O <span class="font-narrow text-blue-600">xPDV</span> é implantado a partir do
                        diagnóstico
                        das necessidades organizacionais da sua empresa, proporcionando soluções para os problemas
                        existentes com os melhores processos e controles internos, alinhados às operações específicas de
                        cada organização.</p>

                    <ul class="mt-4 space-y-1">
                        <li class="font-narrow">✔ <span class="font-semibold">Pedido de Compra, Compras e Formação de
                                Preços;</span></li>
                        <li class="font-narrow">✔ <span class="font-semibold">Contas a pagar e Contas a receber;</span>
                        </li>
                        <li class="font-narrow">✔ Tesouraria e Cobrança;</li>
                        <li class="font-narrow">✔ <span class="font-semibold">Vendas, Transferências e
                                Consignação;</span>
                        </li>
                        <li class="font-narrow">✔ Comissões de vendas;</li>
                        <li class="font-narrow">✔ Logística;</li>
                        <li class="font-narrow">✔ Ordem de serviços;</li>
                        <li class="font-narrow">✔ <span class="font-semibold">Livros Fiscais, e exportação de arquivos
                                obrigatórios.</span></li>
                    </ul>
                </div>
                <div class="w-full mt-2">
                    <h1 class="text-xs font-narrow">Características:</h1>
                    <ul class="list-disc pl-4 text-xs">
                        <li class="font-narrow">Interface moderna gráfica e intuitiva.</li>
                        <li class="font-narrow">Plataforma Windows 7, Windows 10, Windows 11.</li>
                        <li class="font-narrow">Banco de dados Postgree SQL.</li>
                        <li class="font-narrow">Atende todos os seguimentos de comércio, serviços e pequenas indústrias.
                        </li>
                    </ul>
                </div>

            </main>

            <footer class="flex flex-col items-center">
                <p>------------------------------------------------------------------------------------------</p>
                <p class="text-xs text-center">
                    Next Company - Infocom Informática - Rua Fernando Pires Lead, Nº 2000 - Teresina PI - (86) 3301-5350
                </p>
            </footer>
    </div>
    <div class="new-page container flex flex-col justify-between h-screen px-4">
        <header class="mt-8 mb-2 flex flex-row justify-between items-center">
            <img src="https://imgur.com/01PjkOR.png" class="h-[70px]" alt="nextcompany">
            <img src="https://imgur.com/03VWLf0.png" class="h-[80px]" alt="axell">
        </header>
        <main>
            <div class="max-w-3xl  mx-auto bg-white p-6 rounded-lg">
                <h1 class="text-xl font-narrow mb-4">2.0 - DA IMPLANTAÇÃO:</h1>

                <h2 class="text-xs font-narrow mt-4">Descrição:</h2>
                <p class="text-xs font-narrow">Trata-se do processo de planejamento, instalação, configuração de parâmetros e todos os processos
                    internos dos sistemas necessários ao funcionamento do mesmo.</p>
                <ul class="list-disc pl-6 space-y-1 mt-2">
                    <li class="text-xs font-narrow">Levantamento de requisitos referente à forma de trabalho do cliente e adequação do uso ao
                        sistema;</li>
                    <li class="text-xs font-narrow">Análise de recursos referentes aos principais cadastros;</li>
                    <li class="text-xs font-narrow">Análise de recursos referente à tributação;</li>
                    <li class="text-xs font-narrow">Análise de necessidades de relatórios diários, semanais e mensais;</li>
                </ul>

                <h2 class="text-xs font-narrow mt-4">Treinamento:</h2>
                <p class="text-xs font-narrow">Processo necessário para qualificação dos recursos humanos da empresa na utilização dos sistemas em
                    níveis operacionais, gerenciais e administrativos.</p>
                <p class="text-red-600 text-xs font-narrow">Versão Lite: 8h de Treinamento</p>

                <h2 class="text-xs font-narrow mt-4">Migração:</h2>
                <p class="text-xs font-narrow">Quando há necessidade de migração de dados de um banco de dados de sistema legado para o novo, será
                    efetuado um estudo de viabilidade para importação dos cadastros e de movimentos e quando viável
                    aumento para os usuários do sistema.</p>

                <h2 class="text-xs font-narrow mt-4">Preço da Implantação:</h2>
                <table class=" w-full h-[120px] border border-gray-300 mt-2 text-left">
                    <thead>
                        <tr class="bg-gray-200">
                            <th class="border font-narrow text-xs px-4 py-2">Item</th>
                            <th class="border font-narrow text-xs px-4 py-2">Descrição</th>
                            <th class="border font-narrow text-xs px-4 py-2">Qtd.</th>
                            <th class="border font-narrow text-xs px-4 py-2">Valor unitário R$</th>
                            <th class="border font-narrow text-xs px-4 py-2">Valor total R$</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${dados
                        .map(
                        (item, index) => `
                        <tr>
                            <td class="border font-narrow text-xs px-4 py-2">${index + 1}</td>
                            <td class="border font-narrow text-xs px-4 py-2">${item.product.name}</td>
                            <td class="border font-narrow text-xs px-4 py-2">${item.quantity}</td>
                            <td class="border font-narrow text-xs px-4 py-2">${new Intl.NumberFormat('pt-BR', { style: 'currency',
                                currency: 'BRL' }).format(item.deploy)}</td>
                            <td class="border font-narrow text-xs px-4 py-2">${new Intl.NumberFormat('pt-BR', { style: 'currency',
                                currency: 'BRL' }).format(item.deploy)}</td>
                        </tr>
                        `
                        )
                        .join("")}
                    </tbody>
                </table>
                <p class="mt-2 text-red-600 font-narrow">
                    Extenso:(${extenso(dados.reduce((total, item) => total + (item.deploy), 0), { mode: 'currency' })}).
                    Pagamento a Prazo
                    ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(dados.reduce((total,
                    item) => total + (item.deploy), 0))}
                </p>
                <h2 class="text-xs font-narrow mt-4">Condições Comerciais da Implantação:</h2>
                <ul class="list-disc pl-6 space-y-1">
                    <li class="text-xs font-narrow">Para implantação e suporte em cidades com distância superior a 50 km
                        da sede da contratada, as
                        despesas de transporte, traslados, alimentação e hospedagem serão por conta do contratante;</li>
                    <li class="text-xs font-narrow">Cartão em até 3x Sem Juros, ou à vista via Bix ou transferência
                        bancária.</li>
                </ul>
            </div>
        </main>
        <footer class="flex flex-col items-center">
            <p>------------------------------------------------------------------------------------------</p>
            <p class="font-narrow text-xs text-center">
                Next Company - Infocom Informática - Rua Fernando Pires Lead, Nº 2000 - Teresina PI - (86) 3301-5350
            </p>
        </footer>
    </div>
    <div class="new-page container flex flex-col justify-between h-screen px-4">
        <header class="flex flex-row justify-between items-center">
            <img src="https://imgur.com/01PjkOR.png" class="h-[70px]" alt="nextcompany">
            <img src="https://imgur.com/03VWLf0.png" class="h-[80px]" alt="axell">
        </header>
        <main>
            <div class="max-w-3xl mx-auto bg-white p-6 ">
                <h2 class="text-xl font-narrow">3.0 DO LICENCIAMENTO:</h2>
                <p class="mt-2 font-narrow text-xs">Trata-se da contratação do direito de uso do sistema de forma temporária com
                    pagamento
                    mensal. No licenciamento, além do direito de uso, o cliente também passa a ter direito no suporte
                    técnico que abrange correções e atualizações do sistema.</p>

                <h3 class="mt-4 font-narrow text-xs">Preços do licenciamento:</h3>
                <table class="w-full mt-2 border-collapse border border-gray-300">
                    <thead>
                        <tr class="bg-gray-200">
                            <th class="border border-gray-300 font-narrow text-xs px-2 py-1">Item</th>
                            <th class="border border-gray-300 font-narrow text-xs px-2 py-1">Descrição</th>
                            <th class="border border-gray-300 font-narrow text-xs px-2 py-1">Qtd.</th>
                            <th class="border border-gray-300 font-narrow text-xs px-2 py-1">Valor unitário R$</th>
                            <th class="border border-gray-300 font-narrow text-xs px-2 py-1">Valor total R$</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${dados
                        .map(
                        (item, index) => `
                        <tr>
                            <td class="border border-gray-300 font-narrow text-xs px-2 py-1 text-center">${index + 1}</td>
                            <td class="border border-gray-300 font-narrow text-xs px-2 py-1">${item.product.name}</td>
                            <td class="border border-gray-300 font-narrow text-xs px-2 py-1 text-center">${item.quantity}</td>
                            <td class="border border-gray-300 font-narrow text-xs px-2 py-1 text-center">${new
                                Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.price)}
                            </td>
                            <td class="border border-gray-300 font-narrow text-xs px-2 py-1 text-center">${new
                                Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.price)}
                            </td>
                        </tr>
                        `
                        )
                        .join("")}
                    </tbody>
                </table>
                <p class="mt-2 text-red-600 text-xs font-narrow">
                    Extenso:(${extenso(dados.reduce((total, item) => total + (item.price - item.discount), 0), { mode:
                    'currency' })}).Valor a pagar
                    ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(dados.reduce((total,
                    item) => total + (item.price - item.discount), 0))}
                </p>

                <h3 class="mt-4 text-xs font-narrow">Condições Comerciais:</h3>
                <ul class="list-disc text-xs ml-6 mt-2">
                    <li class="font-narrow text-xs ">Para suporte técnico presencial em cidades com distância superior a
                        50 km da sede da contratada,
                        as despesas de transporte, estadia, alimentação e hospedagem serão por conta da contratante;
                    </li>
                    <li class="font-narrow text-xs ">Forma de pagamento do licenciamento: mensal;</li>
                    <li class="font-narrow text-xs ">Duração do contrato: mínimo de 24(vinte e quatro) meses;</li>
                    <li class="font-narrow text-xs ">Reajuste: anual de acordo com o reajuste do salário-mínimo vigente
                        no país.</li>
                </ul>

                <h2 class="mt-6 text-xl font-narrow">4.0 DA PROPOSTA:</h2>
                <ul class="list-disc ml-6 mt-2">
                    <li class="font-narrow text-xs ">Esta proposta é documento contratual da implantação do sistema;
                    </li>
                    <li class="font-narrow text-xs ">Esta proposta exige um contrato adicional para a licenciamento do
                        sistema;</li>
                    <li class="font-narrow text-xs ">Esta proposta tem validade de 10 (dez) dias a partir da data de
                        emissão.</li>
                </ul>

                <p class="mt-4 text-xs">Teresina, Data: ${date} de ${month} de ${year}.</p>
                <p class="font-narrow text-xs">Atenciosamente,</p>
                <div class="flex flex-row w-full justify-between">
                    <div class="mt-6">
                        <p class=" font-narrow border-t w-[250px] border-black mt-6">${dados[0].business.businessSellers[0]?.Seller?.name || ''}</p>
                    </div>

                    <div class="mt-6 ">
                        <p class="font-narrow border-t w-[250px] border-black mt-6">Aceite:</p>
                    </div>
                </div>
            </div>
        </main>
        <footer class="flex flex-col items-center">
            <p>------------------------------------------------------------------------------------------</p>
            <p class="font-narrow text-xs text-center">
                Next Company - Infocom Informática - Rua Fernando Pires Lead, Nº 2000 - Teresina PI - (86) 3301-5350
            </p>
        </footer>
    </div>
</body>

</html>`;
    };

    const handlePrint = () => {
        if (dados.length === 0) {
            toast({ description: "negócio não possui produtos vinculados", variant: "destructive" });
        }
        if (dados[0].business.businessSellers.length === 0) {
            toast({ description: "Vincule um vendedor ao negócio", variant: "destructive"  });
        }
        else {
            const w = window.open("", '_blank');
            if (w) {
                w.document.open();
                w.document.write(generateHTML());
                w.document.close();
            }
        }
    }
    const handlePrintW = () => {
        if (dados.length === 0) {
            toast({ description: "negócio não possui produtos vinculados" });
        }
        if (dados[0].business.businessSellers.length === 0) {
            toast({ description: "Vincule um vendedor ao negócio" });
        }
        else {
            const w = window.open("", '_blank');
            if (w) {
                w.document.open();
                w.document.write(generateHTMLW());
                w.document.close();
            }
        }
    }

    return (
        <div className='flex flex-row w-screen justify-center items-center'>
            <div className='flex flex-col rounded-lg bg-indigo-50 p-10'>
                <button type="button" onClick={handlePrint} className=" text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Modelo xPDV impressão</button>
                <button type="button" onClick={() => { setModalwCompany(true) }} className=" text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 mt-4 text-center">Modelo wCompany impressão</button>
            </div>
            <FeatureModal
                modalwCompany={modalwCompany}
                setModalwCompany={setModalwCompany}
                handlePrintW={handlePrintW}
                formaPgmt={formaPgmt}
                setFormaPgmt={setFormaPgmt}
                featureNames={dados2}
                onFeaturesChange={setSelectedFeatures}
            />
        </div>
    );
};

export default PrintComponent;